export enum ELogicOperators {
  AND = 'and',
  OR = 'or',
  NOT = 'not',
  INCLUDE = 'include',
  NOT_INCLUDE = 'not_include',
}
